<template>
  <v-app>
    <v-container fluid>
      <!-- <v-btn-toggle
        v-model="mode"
        color="#f87979"
        class="mb-6"
        mandatory
        group
      >
        <v-btn
          value="1"
          color="grey lighten-1"
          style="border-width: 1px; border-radius: 5px"
        >
          <v-icon left> mdi-timer-outline </v-icon>
          <span class="hidden-sm-and-down">TIEMPO REAL</span>
        </v-btn>
        <v-btn
          value="2"
          color="grey lighten-1"
          style="border-width: 1px; border-radius: 5px"
        >
          <v-icon left> mdi-chart-bell-curve-cumulative </v-icon>
          <span class="hidden-sm-and-down">ESTADÍSTICAS</span>
        </v-btn>
      </v-btn-toggle> -->

      <!-- Diálogo -->
      <v-dialog v-model="dialog" max-width="900px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Tiempos de paro de líneas</span>
          </v-card-title>
          <v-card-text>
            <!-- Tabla dentro del diálogo -->
            <v-data-table
              :headers="table_headers_time"
              :items="info_paros"
              class="elevation-1"
            >
              <template v-slot:item.descanso="{ item }">
                <v-chip
                  :color="mode == 1 ? getColorDescanso(item.descanso_vivo, item.descanso) : ''"
                  text-color="black"
                >
                  {{ item.descanso }}
                </v-chip>
              </template>
              <template v-slot:item.noche="{ item }">
                <v-chip
                  :color="mode == 1 ? getColorLimpieza(item.limpieza_vivo, item.noche, 3, getCurrentShift()): ''"
                  text-color="black"
                >
                  {{ item.noche }}
                </v-chip>
              </template>
              <template v-slot:item.manana="{ item }">
                <v-chip
                  :color="mode == 1 ? getColorLimpieza(item.limpieza_vivo, item.manana, 1, getCurrentShift()): ''"
                  text-color="black"
                >
                  {{ item.manana }}
                </v-chip>
              </template>
              <template v-slot:item.tarde="{ item }">
                <v-chip
                  :color="mode == 1 ? getColorLimpieza(item.limpieza_vivo, item.tarde, 2, getCurrentShift()): ''"
                  text-color="black"
                >
                  {{ item.tarde }}
                </v-chip>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-row
        v-if="mode == 2"
        class="mt-0 mb-4 ml-4 mr-4"
      >
        <v-col cols="5">
          <v-select
            v-model="tipo_busqueda"
            placeholder="Busqueda por ..."
            :items="tipos_busqueda_fecha"
            prepend-icon="mdi-calendar"
            item-text="name"
            hide-details
            class="ma-0 pa-0"
            return-object
          ></v-select>
          <v-text-field
            v-if="tipo_busqueda.value === 'day'"
            v-model="date"
            type="date"
            outlined
            clearable
            required
          ></v-text-field>
          <v-text-field
            v-if="tipo_busqueda.value === 'week'"
            v-model="date"
            type="week"
            outlined
            clearable
            required
          ></v-text-field>
          <v-text-field
            v-if="tipo_busqueda.value === 'month'"
            v-model="date"
            type="month"
            outlined
            clearable
            required
          ></v-text-field>
        </v-col>

        <v-col cols="5">
          <v-select
            v-if="tipo_busqueda.value === 'day'"
            prefix="Turno: "
            v-model="selected_shift"
            placeholder="Seleccionar turno..."
            :items="shift_list"
            prepend-icon="mdi-account-clock-outline"
            item-text="name"
            item-value="id"
            hide-details
            class="ma-0 pa-0"
          ></v-select>
        </v-col>

        <v-col cols="2">
          <v-btn 
            :disabled="disableSearchBtn"
            @click="buscar"
          >
            Buscar
          </v-btn>
        </v-col>
      </v-row>

       <!-- Botón de información -->
       <v-btn
        icon
        color="primary"
        @click="dialog = true"
        class="info-button"
        elevation="2"
      >
        <v-icon>mdi-information</v-icon>
      </v-btn>

      <v-row>
        <v-col cols="12">
          <v-data-table
            ref="line_table"
            :headers="mode == 2 ? table_header_statistics : table_header_real_time"
            :items="lines"
            hide-default-footer
            class="elevation-1"
            @click:row="showChart"
            :item-class="getRowClass"
            :no-data-text="
              mode == 2
                ? 'No se han encontrado resultados para la fecha indicada'
                : 'No se han encontrado resultados para el turno actual'
            "
            :loading="loading"
            loading-text="Obteniendo datos..."
          >
            <template v-slot:[`item.tiempo_utilizacion`]="{ item }">
              {{ item.register_number ? `${item.tiempo_utilizacion}%` : "SIN DATOS" }}
            </template>
            <template v-slot:[`item.tiempo_produccion`]="{ item }">
              {{ item.register_number ? `${item.tiempo_produccion}%` : "SIN DATOS" }}
            </template>
            <template v-slot:[`item.color_marcha`]="{ item }">
              <v-icon :color="item.color_marcha">mdi-circle</v-icon>
            </template>
            <template v-slot:[`item.show_chart`]="{ item }">
              <v-btn
                small
                :disabled="!item.register_number || graficDisable"
              >
                VER GRÁFICO
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <v-row>
        <!-- Botón de descarga -->
        <v-col cols="12" class="d-flex justify-end" v-if="mode == 2">
          <v-btn @click="downloadExcel" :disabled="disableDownloadBtn">
            <v-icon left> mdi-download </v-icon>
            <span class="hidden-sm-and-down">Descargar Excel</span>
          </v-btn>
        </v-col>
      </v-row>

      <!-- Selector de graficas entre tiempo real y grafica acumulados -->
      <v-btn-toggle
        v-if="graficToggle"
        v-model="graficMode"
        color="#f87979"
        class="mb-6"
        mandatory
        group
      >
        <v-btn
          value="1"
          color="grey lighten-1"
          style="border-width: 1px; border-radius: 5px"
        >
          <v-icon left> mdi-timer-outline </v-icon>
          <span class="hidden-sm-and-down">TIEMPO REAL</span>
        </v-btn>
        <v-btn
          value="2"
          color="grey lighten-1"
          style="border-width: 1px; border-radius: 5px"
        >
          <v-icon left> mdi-chart-bell-curve-cumulative </v-icon>
          <span class="hidden-sm-and-down">ACUMULADO</span>
        </v-btn>
      </v-btn-toggle>


      <!-- Seleccionar intervalos de tiempo para mostrar en grafica acumulados -->
      <v-select
        v-if="selectTimeAcumulado"
        v-model="opcion_acumulado"
        placeholder="Seleccionar intervalo de tiempo..."
        :items="opciones_acumulado"
        prepend-icon="mdi-account-clock-outline"
        item-text="name"
        item-value="value"
        hide-details
        class="ma-0 pa-0"
      ></v-select>
      <div class="text-center mt-4">
        <h2 class="text-h5 font-weight-bold mb-2">{{ clicked?.name }}</h2>
        <v-divider class="mx-auto" style="max-width: 200px;"></v-divider>
      </div>

      <v-divider></v-divider>

      <v-row>
        <v-col cols="12">
          <div
            v-for="(statistic, statistic_index) in statistics"
            :key="statistic_index"
          >
            <LineChart :chartData="statistic"/>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import moment from "moment";
import * as XLSX from "xlsx";

import { mapState, mapActions } from "vuex";

import LineChart from "@/components/LineChart.vue";

export default {
  components: {
    LineChart,
  },

  data() {
    return {
      mode: "2",
      graficMode: "1",

      dialog: false,

      datePicker: false,
      date: null,
      date_busqueda: null,

      clicked: null,
      clickedRow: null,

      opciones_acumulado: [
        { name: "15 minutos", value: 15 },
        { name: "30 minutos", value: 30 },
        { name: "1 hora", value: 60 },
      ],
      opcion_acumulado: null,

      tipos_busqueda_fecha: [
        { name: "Día", value: "day" },
        { name: "Semana", value: "week" },
        { name: "Mes", value: "month" },
      ],
      tipo_busqueda: { name: "Día", value: "day" },

      shift_list: [
        { id: 3, name: "Noche" },
        { id: 1, name: "Mañana" },
        { id: 2, name: "Tarde" },
        // { id: null, name: "Todos" },
        { id: 4, name: "Todos" },
      ],
      selected_shift: null,
      shift_busqueda: null,

      //Cabecera de tabla en tiempo real
      table_header_real_time: [
        { text: "LÍNEA", value: "id" },
        { text: "Minutos encendido", value: "minutos_encendido" },
        { text: "Minutos apagado", value: "minutos_apagado" },
        { text: "Tiempo disponible", value: "tiempo_disponible" },
        { text: "% Tiempo encendida", value: "tiempo_utilizacion" },
        { text: "Minutos de descanso", value: "minutos_descanso" },
        { text: "Minutos en producción", value: "minutos_produccion" },
        { text: "% Tiempo en producción", value: "tiempo_produccion" },
        { text: "Nº Ciclos", value: "ciclos" },
        { text: "Ciclos totales", value: "ciclos_totales" },
        { text: "Ciclos/minuto", value: "media_ciclos" },
        { text: "Ciclos/minutos disponibles", value: "media_ciclos_disponible" },
        { text: "Paros", value: "paros_linea" },
        { text: "Marcha", value: "color_marcha" },
        { text: "Ver gráfico", value: "show_chart" },
      ],
      //Cabecera de tabla de historico
      table_header_statistics: [
        { text: "LÍNEA", value: "id" },
        { text: "Minutos encendido", value: "minutos_encendido" },
        { text: "Minutos apagado", value: "minutos_apagado" },
        { text: "Tiempo disponible", value: "tiempo_disponible" },
        { text: "% Tiempo encendida", value: "tiempo_utilizacion" },
        { text: "Minutos de descanso", value: "minutos_descanso" },
        { text: "Minutos en producción", value: "minutos_produccion" },
        { text: "% Tiempo en producción", value: "tiempo_produccion" },
        { text: "Ciclos totales", value: "ciclos_totales" },
        { text: "Ciclos/minuto", value: "media_ciclos" },
        { text: "Ciclos/minutos disponibles", value: "media_ciclos_disponible" },
        { text: "Paros", value: "paros_linea" },
        { text: "Ver gráfico", value: "show_chart" },
        { text: "Nº Ciclos", value: "ciclos" },
        { text: "Marcha", value: "color_marcha" },
      ],
      //Cabeceras de tabla de tiempos de limpieza y descansos
      table_headers_time: [
        { text: "LÍNEA", value: "name" },
        { text: "Tiempo de descanso", value: "descanso" },
        { text: "Limpieza Turno NOCHE", value: "noche" },
        { text: "Limpieza Turno MAÑANA", value: "manana" },
        { text: "Limpieza Turno TARDE", value: "tarde" }
      ],

      lines: [], //datos de las lineas
      info_paros: [], //datos de los tiempos de descanso y limpieza
      modIds: [8],

      loading: false, //booleano de carga de datos
      graficDisable: false, // booleano para habilitar el grafico en historicos solo cuando se elige dia

      tiempo_real: [], //array para guardar los datos en tiempo real
      data_mean: [], //array para guardar los datos de acumulado
      statistics: [],//para guardar los datos de la grafica de una linea
      
      idsInAllStatistics: [],
      allStatistics: [], //para guardar los datos de la grafica de todas las lineas en estadisticas

      showing_line: null,
      selected_rows: [], // Array to keep track of selected rows

      marchasAndCiclos: [],
    };
  },

  computed: { 
    ...mapState("nodered", ["client"]),

    //Booleano para habilitar/deshabilitar el boton de busqueda
    disableSearchBtn (){
      return this.date == null;
    },

    //Booleano para habilitar/deshabilitar el boton de descarga
    //si estamos buscando por dia, tenemos que tener en cuenta el turno y la fecha
    //si estamos buscando por semana y mes, tenemos que tener en cuenta solo la fecha
    disableDownloadBtn() {
      return this.tipo_busqueda.value == "day" ? this.selected_shift != this.shift_busqueda || this.date != this.date_busqueda : this.date != this.date_busqueda;
    },

    //Booleano para habilitar/deshabilitar selector de grafico
    graficToggle() {
      return this.clicked && !this.graficDisable;
    },

    //Boleano para mostrar selector de tiempo en grafico acumulado
    selectTimeAcumulado() {
      return this.graficToggle && this.graficMode == "2";
    }

  },

  watch: {
    //cambio de modo estadisticas/tiempo real
    // mode(newVal) {
    //   //cambiamos el modo al correspondiente
    //   this.mode = newVal;
    //   //cambiamos el modo de grafico a tiempo real
    //   this.graficMode = "1";

    //   //al cambiar de pagina establecemos el tipo de fecha en formato dia por defecto
    //   this.tipo_busqueda = this.tipos_busqueda_fecha[0];
    //   this.selected_shift = this.shift_list.filter((turno) => turno.id == this.getCurrentShift())[0].id;
      
    //   this.date = moment();
    //   //si estamos en el turno de noche, cogemos el dia siguiente --> el dia empieza con el turno de noche
    //   if (this.selected_shift == 3) this.date.add(1, "day");
    //   this.date = this.date.format("YYYY-MM-DD");

    //   this.buscar();
    //   //vaciamos el grafico y dejamos a null la linea seleccionada
    //   this.data_mean = [];
    //   this.tiempo_real = [];
    //   this.statistics = [];
    //   this.clicked = null;
    //   this.clickedRow = null;
    // },
    //cambio de modo de grafica
    graficMode(newVal) {
      //si val es 1, mostramos en tiempo real, si es 2 mostramos la media/acumulado
      this.statistics = newVal == "1" ? this.tiempo_real : this.data_mean;
    },
    opcion_acumulado() {
      this.data_mean = this.generateDataGraphicAcumulados(this.tiempo_real);
      this.statistics = this.data_mean;
    },
    //cuando cambiamos de fecha, establecemos por defecto dia/semana/mes actual
    tipo_busqueda() {
      if (this.tipo_busqueda.value == "day") this.date = moment().format("YYYY-MM-DD");
      else if (this.tipo_busqueda.value == "week") this.date = moment().format("YYYY-[W]WW");
      else this.date = moment().format("YYYY-MM");
    }
  },

  methods: {
    ...mapActions(["getData", "logout"]),
    ...mapActions("nodered", ["doSubscribe", "doUnsubscribe"]),

    //funcion para generar los parametros que se envian al back
    generateOutput(modo = 2) {
      const timestamps = this.getStartAndEndTimestamps(modo);
  
      // Convertir cada timestamp de la zona horaria de Madrid a UTC
      const startTimestampUTC = moment.tz(timestamps.start_timestamp, "Europe/Madrid").utc().format("YYYY-MM-DD HH:mm:ss");
      const endTimestampUTC = moment.tz(timestamps.end_timestamp, "Europe/Madrid").utc().format("YYYY-MM-DD HH:mm:ss");

      // Crear un nuevo objeto con los timestamps ajustados a UTC
      const output = {
          start_timestamp: startTimestampUTC,
          end_timestamp: endTimestampUTC
      };

      return output;
    },

    //Funcion para recoger los datos de todas las lineas en el momento que se ha hecho la busqueda en el historico
    async getMomentLineData(lines, output) {
      for (const linea of lines) {
        if (!this.idsInAllStatistics.includes(linea.id)) {
          this.idsInAllStatistics.push(linea.id);
          const { line } = await this.getData({ path: `production/lines/${linea.id}`, params: output });
          this.allStatistics.push(line);
        }
      }
    },

    //funcion para recoger los datos de produccion en base de datos
    //funcion de busqueda en base de datos
    async buscar() {
      try {
        this.loading = true;

        if(this.mode == "2") {
          this.clicked = null;
          this.clickedRow = null;
        }

        this.allStatistics = [];
        this.idsInAllStatistics = [];
        if (!this.clicked || this.mode == "2") this.statistics = [];
        if (this.selected_rows.length) this.selected_rows[0].select(false);
        
        // console.log(this.getStartAndEndTimestamps());
        const output = this.generateOutput();

        // console.log("El output que vamos a consultar es:", output)

        const { lines } = await this.getData({ path: "production/lines", params: output });
        //si estamos en el modo de estadisticas, guardamos los datos de la grafica en ese momento
        if (this.mode == "2" && this.allStatistics.length == 0 && this.tipo_busqueda.value == "day") {
          await this.getMomentLineData(lines, output);
        }
        //guardamos las marchas y ciclos del inicio
        if(this.marchasAndCiclos.length == 0) {
          this.marchasAndCiclos = lines.map((l) => ({
            id: l.id,
            color_marcha: l.color_marcha,
            ciclos: l.ciclos,
          }));
        }

        //modificar el id de 8 para evitar confusiones (id 8 es para la linea 9)
        const modLines = lines.map((linea) => {
          if(this.modIds.includes(linea.id)) linea.id = linea.id + 1;
          return linea;
        });
        this.lines = modLines;
        if(this.marchasAndCiclos.length > 0){
          //Modificamos los valores de ciclos y marcha en tiempo real
          this.lines = this.lines.map(line => {
            const newData = this.marchasAndCiclos.find(newItem => newItem.id === line.id);
            if (newData) {
              return {
                ...line, // Mantener el resto de propiedades
                color_marcha: newData.color_marcha,
                ciclos: newData.ciclos
              };
            }
            return line;
          });
        }
        // console.log(this.lines);
        
        //guardamos los datos sobre los tiempos de paro
        this.info_paros = this.lines.map(line => ({
          name: line.name,
          descanso: line.tiempo_paro.descanso,
          descanso_vivo: line.tiempo_paro.descanso_vivo,
          noche: line.tiempo_paro.noche,
          manana: line.tiempo_paro.manana,
          tarde: line.tiempo_paro.tarde,
          limpieza_vivo: line.tiempo_paro.limpieza_vivo,
        }));
        // console.log(this.info_paros);
        this.loading = false;
        this.shift_busqueda = this.selected_shift;
        this.date_busqueda = this.date;

      } catch (error) {
        console.error(`Error al buscar historico: ${error}`);
      }
    },

    //funcion para recoger ciclos y estado maquina en tiempo real
    async getMarchaAndCicles() {
      try {
        this.loading = true;
        // console.log(this.getStartAndEndTimestamps());
        const output = this.generateOutput(1);

        const { lines } = await this.getData({ path: "production/lines", params: output });

        //recogemos los datos de marcha y ciclos
        this.marchasAndCiclos = lines.map((l) => ({
          id: l.id,
          color_marcha: l.color_marcha,
          ciclos: l.ciclos,
        }));

        //Modificamos los valores de ciclos y marcha en tiempo real
        this.lines = this.lines.map(line => {
          const newData = this.marchasAndCiclos.find(newItem => newItem.id === line.id);
          if (newData) {
            return {
              ...line, // Mantener el resto de propiedades
              color_marcha: newData.color_marcha,
              ciclos: newData.ciclos
            };
          }
          return line;
        });

        this.loading = false;

      } catch (error) {
        console.error(`Error al buscar historico: ${error}`);
      }
    },
    //cambiar el formato de fecha de los labels de las graficas
    changeLabelFormat(line) {
      line.ciclos_turno.forEach((entry) => {
        entry.datasets.forEach(dataset => {
            const [start, end] = dataset.label.split(" : ");

            // Obtener la fecha actual en formato YYYY-MM-DD
            const today = moment().format("YYYY-MM-DD");

            // Convertir ambas horas a la zona horaria de Madrid
            const startMadrid = moment.utc(`${today} ${start}`, "YYYY-MM-DD HH:mm").tz("Europe/Madrid").format("HH:mm");
            const endMadrid = moment.utc(`${today} ${end}`, "YYYY-MM-DD HH:mm").tz("Europe/Madrid").format("HH:mm");

            // Asignar el nuevo valor al label en el formato "HH:mm : HH:mm"
            dataset.label = `${startMadrid} : ${endMadrid}`;
        });

        // Convertir cada fecha en labels a la zona horaria de Madrid
        entry.labels = entry.labels.map(label =>
            moment.utc(label, "YYYY-MM-DD HH:mm").tz("Europe/Madrid").format("YYYY-MM-DD HH:mm")
        );
      });
      //ponemos a true formattedLabels para no volver a editarlos
      if (this.mode == "2") line.formattedLabels = true;
    },

    //funcion para crear el grafico al hacer click en una de las lineas
    async showChart(item, row) {
      this.clicked = item;
      this.clickedRow = row;

      //dejar la linea 9 con el id original
      const id = this.modIds.includes(item.id - 1) ? item.id - 1 : item.id;

      //Modo de historico
      if (this.mode == "2") {
        //solo dibujar grafico en estadisticas si el tipo de busqueda es el dia
        if (!this.graficDisable) {
          //eliminamos los elementos que son null
          this.allStatistics = this.allStatistics.filter(stat => stat != null);
          //recogemos los datos de la linea seleccionada desde el array de estadisticas
          const ciclos_turno_linea = this.allStatistics.filter(stat => stat.id == id)[0];
          
          //comprobamos si se han modificado los labels del turno para evitar modificarlos de nuevo
          if (!ciclos_turno_linea?.formattedLabels) {
            this.changeLabelFormat(ciclos_turno_linea);
          }

          // this.statistics = ciclos_turno_linea.ciclos_turno;
          //dependiendo del modo de grafico seleccionado, mostramos los datos
          this.tiempo_real = ciclos_turno_linea.ciclos_turno;
          this.data_mean = this.generateDataGraphicAcumulados(ciclos_turno_linea.ciclos_turno);

          this.statistics = this.graficMode == "1" ? this.tiempo_real : this.data_mean;
          //recoger el maximo para poner limite al eje y
          for (let dataset of this.statistics){
            const soloNumeros = dataset.datasets[0].data .filter(Number.isFinite)
            let val = null;
            if (soloNumeros.length > 0) val = Math.ceil(Math.max(...soloNumeros) / 5) * 5;
            dataset.max = val;
          }
          
        }
        //Modo tiempo real
      } else {
        //cada vez que llega el topic UPDATE, se actualiza el grafico con los datos mas recientes de la bbdd
        try {
          if (this.selected_rows.length) this.selected_rows[0].select(false);
          row.select(true);
          this.selected_rows = [row];

          const output = this.generateOutput();
  
          const [{ line }, { statistics }] = await Promise.all([
            this.getData({ path: `production/lines/${id}`, params: output }),
            this.getData({
              path: "production/lines",
              params: { ...output },
            }),
          ]);
          this.line = line;
          // Iterar sobre cada objeto en el array
          this.changeLabelFormat(line);

          //guardamos los datos reales en tiempo_real y el acumulado en data_mean
          this.tiempo_real = line.ciclos_turno; 
          this.data_mean = this.generateDataGraphicAcumulados(line.ciclos_turno);
          
          //segun el tipo de grafica selecciondo, mostramos unos datos
          this.statistics = this.graficMode == "1" ? this.tiempo_real : this.data_mean;

          //recoger el maximo para poner limite al eje y
          for (let dataset of this.statistics){
            const soloNumeros = dataset.datasets[0].data .filter(Number.isFinite)
            let val = null;
            if (soloNumeros.length > 0) val = Math.ceil(Math.max(...soloNumeros) / 5) * 5;
            dataset.max = val;
          }

        } catch (error) {
          console.error(`Error al coger datos del grafico: ${error}`);
        }
        
      }
    },

    getRowClass(item) {
      return this.clicked == item ? "selected-row" : "";
    },

    getStartAndEndTimestamps(modo) {
      let start_timestamp = modo == 2 ? moment(this.date) : moment();
      let end_timestamp = modo == 2 ? moment(this.date) : moment();
      // this.tipo_busqueda = this.mode == 1 ? this.tipos_busqueda_fecha.filter((tipo) => tipo.value == "day") : this.tipo_busqueda;

      if (this.tipo_busqueda.value === "day") {
        // const reference_shift = this.mode == 2 ? this.selected_shift : this.getCurrentShift();
        const reference_shift = modo == 2 ? this.selected_shift ? this.selected_shift : this.getCurrentShift() : this.getCurrentShift();
        
        switch (reference_shift) {
          case 1:
            start_timestamp.set({ hour: 6, minute: 0, second: 0 });
            end_timestamp.set({ hour: 13, minute: 59, second: 59 });
            break;

          case 2:
            start_timestamp.set({ hour: 14, minute: 0, second: 0 });
            end_timestamp.set({ hour: 21, minute: 59, second: 59 });
            break;

          case 3:
            start_timestamp.set({ hour: 22, minute: 0, second: 0 });
            end_timestamp.set({ hour: 5, minute: 59, second: 59 });
            
            this.mode == 2 ? start_timestamp.subtract(1, "day") : end_timestamp.add(1, "day");
            //start_timestamp.subtract(1, "day");
            // end_timestamp.add(1, "day");
            break;

          case 4:
            start_timestamp.set({ hour: 22, minute: 0, second: 0 });
            start_timestamp.subtract(1, "day");
            end_timestamp.set({ hour: 21, minute: 59, second: 59 });
            // start_timestamp.set({ hour: 6, minute: 0, second: 0 });
            // end_timestamp.add(1, "day");
            // end_timestamp.set({ hour: 5, minute: 59, second: 59 });
            break;
        }
        start_timestamp = start_timestamp.format("YYYY-MM-DD HH:mm:ss");
        end_timestamp = end_timestamp.format("YYYY-MM-DD HH:mm:ss");

        //habilitamos el grafico
        this.graficDisable = false;

      } else if (this.tipo_busqueda.value === "week") {
        //cogemos el inicio de semana como el domingo a las 22.00
        const start_of_week = moment(this.date).startOf("isoWeek").subtract(1, "days");
        //final de la semana domingo a las 21.59
        const end_of_week = start_of_week.clone().add(7, "days");
        start_of_week.hour(22).minute(0).second(0);
        end_of_week.hour(21).minute(59).second(59);

        start_timestamp = start_of_week.format("YYYY-MM-DD HH:mm:ss");
        end_timestamp = end_of_week.format("YYYY-MM-DD HH:mm:ss");

        //deshabilitamos el grafico
        this.graficDisable = true;

      } else {
        const start_of_month = moment(this.date, "YYYY-MM").startOf("month").subtract(1, "days");
        const end_of_month = moment(this.date, "YYYY-MM").endOf("month");
        start_of_month.hour(22).minute(0).second(0);
        end_of_month.hour(21).minute(59).second(59);


        start_timestamp = start_of_month.format("YYYY-MM-DD HH:mm:ss");
        end_timestamp = end_of_month.format("YYYY-MM-DD HH:mm:ss");

        //deshabilitamos el grafico
        this.graficDisable = true;
      }
      return { start_timestamp, end_timestamp };
    },

    getCurrentShift() {
      const reference_now_hour = moment().hour();
      if (reference_now_hour >= 6 && reference_now_hour < 14) return 1;
      else if (reference_now_hour >= 14 && reference_now_hour < 22) return 2;
      else return 3;
    },

    getShift(val) {
      return val == 1 ? "manana" : val == 2 ? "tarde" : val == 3 ? "noche" : "todos";
    },

    //Funcion para recoger horas/minutos en formato int
    parseHourandMinutes(hora, type) {
      return type == "h" ? parseInt(hora.split(" ")[1].split(":")[0], 10) :
                           parseInt(hora.split(" ")[1].split(":")[1], 10);
    },

    //funcion para añadir los datos a la estrucctura
    addData(horasGrafico, hora, ciclos, dataGrafico, acumulados, dataCiclos, difCiclos) {
      horasGrafico.push(hora);
      dataGrafico.push((ciclos != null ? acumulados : null));
      dataCiclos.push((ciclos != null ? difCiclos / this.opcion_acumulado : null));
    },

    generateDataset(data, dataCiclos, hours) {
      const dataset = [
      {
        borderColor: "rgb(255, 0, 0)",
        data: data,
        label: "Acumulado Turno"
      },
      {
        borderColor: "rgb(0, 255, 0)",
        data: dataCiclos,
        label: `Promedio de ciclos en ${ this.opcion_acumulado ? this.opcion_acumulado : 0 } mins`
      },
    ];
      const labels = hours;

      return {datasets: dataset, labels: labels};
    },

    //generar datos para la grafica de media y acumulacion de ciclos
    generateDataGraphicAcumulados(ciclos_turno) {

      //array de datasets
      let datasets = [];

      //contador de ciclos del turno
      let acumuladoCiclos = 0;
      let antCiclosAcumulados = 0;

      //recorremos los datos recogidos de cada turno
      for (let index = 0; index < ciclos_turno.length; index++) {
        const turno = ciclos_turno[index];
        
        //data y hora del turno
        let dataGraficoTurno = [];
        let dataDifCiclos = [];

        let horasGraficoTurno = [];

        //ultima hora del turno
        const horaFinTurno = turno.labels[turno.labels.length - 1];
        const hFin = this.parseHourandMinutes(horaFinTurno, "h");
        const mFin = this.parseHourandMinutes(horaFinTurno, "m") - (index == ciclos_turno.length - 1 ? 1 : 0);
        for (let i = 0; i < turno.labels.length; i++) {
          //hora del array en pos i
          const hora = turno.labels[i];
          const hours = this.parseHourandMinutes(hora, "h");
          const minutes = this.parseHourandMinutes(hora, "m");

          // if (minutes == 59) console.log(`turno ${index}-->minuto:${minutes}`);
          const ciclos = turno.datasets[0].data[i];
          acumuladoCiclos += ciclos;

          if ((hFin == hours && minutes == mFin || minutes % this.opcion_acumulado == 0)) {
            //calculamos la diferencia entre la cantidad de ciclos del ultimo check con el actual
            const difCiclos = acumuladoCiclos - antCiclosAcumulados;
            
            //añadimos a los arrays los datos
            this.addData(horasGraficoTurno, hora,
                ciclos, dataGraficoTurno, acumuladoCiclos,
                dataDifCiclos, difCiclos);

            //actualizamos el contador de ciclos anterior con el nuevo valor
            antCiclosAcumulados = acumuladoCiclos;
          }
        }
        //generamos el dataset correspondiente al turno
        const datasetTurno = this.generateDataset(dataGraficoTurno, dataDifCiclos, horasGraficoTurno);
        
        //lo agregamos al array de datasets
        datasets.push(datasetTurno);
      }

      return datasets;
    },

    //Color tiempo descanso en tabla de info
    getColorDescanso(val, humbral) {
      if (val == 0) return "#ff8888";
      else if (val < humbral) return "#ffe288";
      else return "#65ff4d";
    },
    //Color tiempo limpieza en tabla de info
    getColorLimpieza(val, humbral, shift, actual) {
      if (actual != shift){
        if (actual == 3) return "#ff8888";
        else if(actual == 1) return shift == 3 ? "#65ff4d" : "#ff8888";
        else return "#65ff4d" 
      } else {
        if (val == 0) return "#ff8888";
        else if (val < humbral) return "#ffe288";
        else return "#65ff4d";
      }

    },

    downloadExcel() {
      if (this.table_header_statistics.length > 1) {
        // Filtrar los headers que no quieres incluir en el Excel
        const headersToInclude = this.table_header_statistics.filter(header => 
          !['show_chart', 'ciclos', 'color_marcha'].includes(header.value)
        );

        // Crear la hoja con solo los headers filtrados
        const ws = XLSX.utils.aoa_to_sheet([headersToInclude.map((header) => header.text)]);

        this.lines.forEach((item) => {
          // Mapear solo los valores de los headers que se incluyeron
          const row = headersToInclude.map((header) => 
            (item[header.value] !== null ? item[header.value] : "")
          );
          XLSX.utils.sheet_add_aoa(ws, [row], { origin: -1 });
        });

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Data");
        const file_name = `${this.date}${this.tipo_busqueda.value !== "day" ? "" : `-${this.getShift(this.selected_shift)}`}`;
        XLSX.writeFile(wb, file_name + ".xlsx");
      }
    },
  },

  async mounted() {

    this.tipo_busqueda = this.tipos_busqueda_fecha[0];
    //en el apartado historicos, elegimos como predeterminado el turno actual
    this.selected_shift = this.shift_list.filter((turno) => turno.id == this.getCurrentShift())[0].id;
    this.date = moment();
    //si estamos en el turno de noche, cogemos el dia siguiente --> el dia empieza con el turno de noche
    if (this.selected_shift == 3) this.date.add(1, "day");
    this.date = this.date.format("YYYY-MM-DD");

    this.buscar();
    this.doSubscribe("UPDATE");
    this.client.on("message", (topic, message) => {
      if (topic === "UPDATE" && JSON.parse(new TextDecoder().decode(message)).update) {
        this.getMarchaAndCicles();
        if (this.clicked && this.clickedRow) {
          this.showChart(this.clicked, this.clickedRow);
        }
      }
    });
  },

  beforeDestroy() {
    this.doUnsubscribe("UPDATE");
  },
};
</script>

<style>
tr.v-data-table__selected {
  background: #f8797944 !important;
}
.selected-row {
  background-color: #f8797944; /* Color de fondo para la fila seleccionada */
}
.info-button {
  /* Tamaño del botón */
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Estilo adicional para darle un toque web moderno */
.info-button:hover {
  background-color: rgba(0, 123, 255, 0.1); /* Un azul suave al pasar el mouse */
}
</style>
